// extracted by mini-css-extract-plugin
module.exports = {"variables":"'~css/variables.css'","_zindex-loadingIcon":"1105","root":"Loading_root__1jwLG"};